interface ToElementProps {
  target: HTMLElement;
  customOffset?: number;
  behavior?: ScrollBehavior;
}

export default {
  /**
   * Find the current top offset of element
   */
  getOffsetTop(element: HTMLElement): number {
    const currentScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    return element.getBoundingClientRect().top + currentScrollPosition;
  },

  /**
   * Scroll to the target element with offset
   */
  toElement({ behavior = "smooth", customOffset = 0, target }: ToElementProps): void {
    const targetOffsetTop = this.getOffsetTop(target);
    const top = targetOffsetTop - customOffset;

    window.scroll({
      behavior,
      top,
    });
  },
};
